import { extendTheme } from '@chakra-ui/react'

export const themeReworth = extendTheme({
  colors: {
    brand: {
      primary: '#2E58FF',
      white: '#FFFFFF',
      modalBackground: '#FFFFFF',
      primaryDark: '#000000',
      secondary: '#2B1EE8',
      secondaryLight: '#1E7CE8',
      secondaryDark: '#001B69',
      bg: '#FAF8FF',
      footer: 'rgb(226, 232, 240)',
      tabText: '#636363',
      tabBorder: '#2E58FF4D',
      tabFilterBG: '#2E58FF4D',
      success: '#1C9E20',
      warning: '#FFD700',
      error: '#F44242',
      avatarBorder: '#2E58FF',
      overlayBG: '#2E58FF',
      cardBG: 'linear-gradient(288deg, #FFFFFF 0%, #E8ECFB 100%)',
      cardShadow: '2px 3px 4px #2E58FF4D',
      cardCategory: '#2E58FF'
    }
  }
})

export const themeClara = extendTheme({
  colors: {
    brand: {
      primary: '#4263EB',
      white: '#FFFFFF',
      modalBackground: '#FFFFFF',
      primaryDark: '#000000',
      secondary: '#2B1EE8',
      secondaryLight: '#1E7CE8',
      secondaryDark: '#1F2223',
      bg: '#F3F5F6',
      footer: 'rgb(226, 232, 240)',
      tabText: '#1F2223',
      tabBorder: '#00000061',
      tabFilterBG: '#2E58FF4D',
      success: '#1C9E20',
      warning: '#FFD700',
      error: '#F44242',
      avatarBorder: '#1F2223',
      overlayBG: '#1F2223',
      cardBG: '#FFFFFF',
      cardShadow: '0px',
      cardCategory: '#1F2223'
    }
  }
})

export const themeCoppel = extendTheme({
  colors: {
    brand: {
      primary: '#3160A6',
      white: '#FFFFFF',
      modalBackground: '#FFFFFF',
      primaryDark: '#2F4F4F',
      secondary: '#3160A6',
      secondaryLight: '#729DC8',
      secondaryDark: '#2F4F4F',
      accentColor: '#F7DD57',
      gray: '#777678',
      bg: '#F5F6FB',
      footer: 'rgb(226, 232, 240)',
      tabText: '#495057',
      tabBorder: '#DFE2E6',
      tabFilterBG: '#2E58FF4D',
      success: '#518536',
      warning: '#FFD700',
      error: '#B15293',
      avatarBorder: '#CFD4D9',
      overlayBG: '#00000014',
      cardBG: '#FFFFFF',
      cardShadow: '0px',
      cardCategory: '#777678'
    }
  }
})

export const themeInvex = extendTheme({
  colors: {
    brand: {
      primary: '#A41D36',
      white: '#FFFFFF',
      modalBackground: '#FFFFFF',
      primaryDark: '#2F4F4F',
      secondary: '#3160A6',
      secondaryLight: '#729DC8',
      secondaryDark: '#2F4F4F',
      accentColor: '#F7DD57',
      gray: '#777678',
      bg: '#FFFFFF',
      footer: 'rgb(226, 232, 240)',
      tabText: '#495057',
      tabBorder: '#A41D36',
      tabFilterBG: 'rgba(164, 29, 54, 0.4)',
      success: '#518536',
      warning: '#FFD700',
      error: '#B15293',
      avatarBorder: '#A41D36',
      overlayBG: 'rgba(164, 29, 54, 0.4)',
      cardBG: '#FFFFFF',
      cardShadow: '2px 3px 4px #585A5F33',
      cardCategory: '#777678'
    }
  }
})

export const themeUniq = extendTheme({
  colors: {
    brand: {
      primary: '#1E3DBC',
      white: '#FFFFFF',
      modalBackground: '#FFFFFF',
      primaryDark: '#04193A',
      secondary: '#04193A',
      secondaryLight: '#0074EE',
      secondaryDark: '#04193A',
      accentColor: '#1E3DBC',
      gray: '#777678',
      bg: '#FFFFFF',
      footer: 'rgb(226, 232, 240)',
      tabText: '#495057',
      tabBorder: '#1E3DBC',
      tabFilterBG: '#1E3DBC',
      success: '#518536',
      warning: '#FFD700',
      error: '#B15293',
      avatarBorder: '#1E3DBC',
      overlayBG: 'rgba(4, 25, 58, 0.6)',
      cardBG: '#FFFFFF',
      cardShadow: '2px 3px 4px #585A5F33',
      cardCategory: '#313131'
    }
  }
})


export const themeFinsus = extendTheme({
  colors: {
    brand: {
      primary: '#FF5F54',
      white: '#FFFFFF',
      modalBackground: '#FFFFFF',
      primaryDark: '#23223F',
      secondary: '#3160A6',
      secondaryLight: '#729DC8',
      secondaryDark: '#23223F',
      accentColor: '#FF5F54',
      gray: '#8c8c8c',
      bg: '#FFFFFF',
      footer: '#E2E8F0',
      tabText: '#23223F',
      tabBorder: '#23223F',
      tabFilterBG: '#23223f66',
      success: '#518536',
      warning: '#FFD700',
      error: '#B15293',
      avatarBorder: '#23223F',
      overlayBG: '#23223f66',
      cardBG: '#FFFFFF',
      cardShadow: '2px 3px 4px #585A5F33',
      cardCategory: '#8c8c8c'
    }
  }
})
  


export const themeLiverpool = extendTheme({
  colors: {
    brand: {
      primary: '#e10098',
      white: '#FFFFFF',
      modalBackground: '#FFFFFF',
      primaryDark: '#04193A',
      secondary: '#04193A',
      secondaryLight: '#0074EE',
      secondaryDark: '#04193A',
      accentColor: '#e10098',
      gray: '#555555',
      bg: '#FFFFFF',
      footer: 'rgb(226, 232, 240)',
      tabText: '#495057',
      tabBorder: '#e10098',
      tabFilterBG: '#e10098',
      success: '#518536',
      warning: '#FFD700',
      error: '#B15293',
      avatarBorder: '#e10098',
      overlayBG: 'rgba(4, 25, 58, 0.6)',
      cardBG: '#FFFFFF',
      cardShadow: '2px 3px 4px #585A5F33',
      cardCategory: '#313131'
    }
  }
  
})

export const themeSuburbia = extendTheme({
  colors: {
    brand: {
      primary: '#552166',
      white: '#FFFFFF',
      modalBackground: '#FFFFFF',
      primaryDark: '#04193A',
      secondary: '#04193A',
      secondaryLight: '#0074EE',
      secondaryDark: '#04193A',
      accentColor: '#552166',
      gray: '#777678',
      bg: '#FFFFFF',
      footer: 'rgb(226, 232, 240)',
      tabText: '#495057',
      tabBorder: '#552166',
      tabFilterBG: '#552166',
      success: '#518536',
      warning: '#FFD700',
      error: '#B15293',
      avatarBorder: '#552166',
      overlayBG: 'rgba(4, 25, 58, 0.6)',
      cardBG: '#FFFFFF',
      cardShadow: '2px 3px 4px #585A5F33',
      cardCategory: '#313131'
    }
  }
  
})
